import React, { useState } from "react"
import { Link } from "gatsby"
import { motion } from "framer-motion"
//Styled Components
import { Container, Flex } from "../../styles/globalStyles"
import {
  HomeFeaturedSection,
  FeaturedContent,
  FeaturedVideo,
  FeaturedProjects,
} from "../../styles/homeStyles"

//Context
import { useGlobalDispatchContext } from "../../context/globalContext"
//Utils
import { autoplayInline } from "../../utils/autoplayInline"

//Scroll Behavior
import { useReveal } from "../../hooks/useReveal"

const HomeFeatured = ({ onCursor }) => {
  const [hovered, setHovered] = useState(false)
  const dispatch = useGlobalDispatchContext()
  const [featuredRef, inView] = useReveal()

  return (
    <HomeFeaturedSection
      ref={featuredRef}
      animate={inView ? "visible" : "hidden"}
      initial="hidden"
      variants={{
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.6,
            ease: [0.6, 0.05, -0.01, 0.9],
          },
        },
        hidden: {
          opacity: 0,
          y: 72,
        },
      }}
    >
      <Container>
        <Link>
          <FeaturedContent
            onHoverStart={() => setHovered(!hovered)}
            onHoverEnd={() => setHovered(!hovered)}
            onMouseEnter={() => onCursor("hovered")}
            onMouseLeave={onCursor}
          >
            <Flex spaceBetween>
              <h3>Featured Project</h3>
              <motion.div
                animate={{ opacity: hovered ? 1 : 0 }}
                className="meta"
              >
                <h4>PEI Seafood</h4>
                <h4>2009</h4>
              </motion.div>
            </Flex>
            <h2 className="featured-title">
              NOT <br /> HUMBLE
              <span className="arrow">
                <motion.svg
                  animate={{ x: hovered ? 48 : 0 }}
                  transition={{ duration: 0.6, ease: [0.6, 0.05, -0.01, 0.9] }}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 101 57"
                >
                  <path
                    d="M33 34H0V24h81.429L66 7.884 73.548 0l19.877 20.763.027-.029L101 28.618 73.829 57l-7.548-7.884L80.753 34H33z"
                    fill="#FFF"
                    fillRule="evenodd"
                  ></path>
                </motion.svg>
              </span>
            </h2>
          </FeaturedContent>
          <FeaturedVideo>
            <video
              ref={autoplayInline}
              loop
              autoPlay
              muted
              playsInline
              src={require("../../assets/video/video.mp4")}
            ></video>
          </FeaturedVideo>
        </Link>
      </Container>
      <Container>
        <FeaturedProjects>
          <Flex flexEnd>
            <button
              onClick={() => dispatch({ type: "TOGGLE_MENU", toggleMenu: true })}
              onMouseEnter={() => onCursor("pointer")}
              onMouseLeave={onCursor}
            >
              <span>All Projects</span>
            </button>
          </Flex>
        </FeaturedProjects>
      </Container>
    </HomeFeaturedSection>
  )
}

export default HomeFeatured
